import { render } from "./Squad.vue?vue&type=template&id=1eb0a743&scoped=true"
import script from "./Squad.vue?vue&type=script&lang=js"
export * from "./Squad.vue?vue&type=script&lang=js"

import "./Squad.vue?vue&type=style&index=0&id=1eb0a743&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-ASPN/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1eb0a743"]])

export default __exports__